package one.healthium.tutorial.navigation.screen

import com.arkivanov.decompose.ComponentContext
import one.healthium.tutorial.domain.TutorialScreenConfig

internal class DefaultTutorialScreenComponent(
    componentContext: ComponentContext,
    override val screenConfig: TutorialScreenConfig,
    private val onNextClicked: () -> Unit,
) : TutorialScreenComponent, ComponentContext by componentContext {
    override fun onNextClicked() {
        onNextClicked.invoke()
    }
}